module.exports = __webpack_public_path__ + "static/media/emojis2_25.ae77c8cb.svg";